import React from 'react';
import styled from 'styled-components';
import { palette } from '../../constants/styles';
import { padding, space, layout } from 'styled-system';

const StyledTable = styled.table`
  background-color: ${palette.sweetGray};
  border-spacing: 0px;
  ${space}
  ${layout}
`;

const StyledHeader = styled.th`
  background-color: ${palette.primaryColor};
  color: white;
  border-left: 1px solid #ffffff44;
  font-weight: 600;
  ${padding}
`;

const StyledCell = styled.td`
  font-weight: 300;
  border-top: 1px solid ${palette.darkerGray};
  text-align: center;
  ${(props) => props.fontWeight && `font-weight: ${props.fontWeight}`}
  ${padding}
`;

export default function Table({ array, headerLimit = 0, boldFirstColumn, ...rest }) {
  return (
    <StyledTable {...rest}>
      {array.map((row, idx) => (
        <tr>
          {row.map((column, colIdx) =>
            idx <= headerLimit ? (
              <StyledHeader padding={['10px', '15px', '20px']}>{column}</StyledHeader>
            ) : colIdx == 0 && boldFirstColumn ? (
              <StyledCell fontWeight="600" padding={['10px', '15px', '20px']}>
                {column}
              </StyledCell>
            ) : (
              <StyledCell padding={['10px', '15px', '20px']}>{column}</StyledCell>
            ),
          )}
        </tr>
      ))}
    </StyledTable>
  );
}
